import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getCategoryWithFilter as asyncGetCategoryWithFilter,
  createCategory as asyncCreateCategory,
  updateCategoryStatus as asyncUpdateCategoryStatus,
  deleteCategory as asyncDeleteCategory,
  bulkDeleteCategory as asyncBulkDeleteCategory,
  getCategoryWithIDS as asyncGetCategoryByID,
  getCategoryWithPage as asyncCategoryWithPage,
} from "../../helpers/apis";
import { showToast } from "../toast/reducer";

// Thunk for fetching categories with filter
export const getCategoryWithFilter = createAsyncThunk(
  "category/getCategoryWithFilter",
  async (req, thunkAPI) => {
    try {
      const response = await asyncGetCategoryWithFilter(req);
      console.log("Fetched categories response:", response); // For debugging
      return response;
    } catch (error) {
      const errorMessage = error?.msg || error.message || "Error fetching categories";
      thunkAPI.dispatch(showToast({ type: "error", msg: errorMessage }));
      throw error;
    }
  }
);

// Thunk for pagination fetch with filter
export const getCategoryWithPage = createAsyncThunk(
  "category/getCategoryWithPage",
  async (req, thunkAPI) => {
    try {
      // const { currentPage = 1, perPage = 20} = req;
      const response = await asyncCategoryWithPage(req);
      console.log("Fetched categories with pagination:", response);
      return {
        data: response.data?.data || [],
        totalCount: response.data?.totalCount || 0,
        currentPage: response.data?.currentPage || 1
      };
    } catch (error) {
      const errorMessage = error?.msg || error.message || "Error fetching categories with pagination";
      thunkAPI.dispatch(showToast({ type: "error", msg: errorMessage }));
      throw error;
    }
  }
);

// Thunk for fetching category by ID
export const getCategoryWithId = createAsyncThunk(
  "category/getCategoryWithId",
  async (categoryId, thunkAPI) => {
    try {
      const response = await asyncGetCategoryByID(categoryId);
      console.log(`Fetched category by ID ${categoryId}:`, response);
      return response;
    } catch (error) {
      const errorMessage = error?.msg || error.message || "Error fetching category by ID";
      thunkAPI.dispatch(showToast({ type: "error", msg: errorMessage }));
      throw error;
    }
  }
);

// Thunk for creating a new category
export const createCategory = createAsyncThunk(
  "category/createCategory",
  async (data, thunkAPI) => {
    try {
      const response = await asyncCreateCategory(data);
      const successMessage = response?.msg || "Category created successfully";
      thunkAPI.dispatch(showToast({ type: "success", msg: successMessage }));
      return response;
    } catch (error) {
      const errorMessage = error?.msg || error.message || "Error creating category";
      thunkAPI.dispatch(showToast({ type: "error", msg: errorMessage }));
      throw error;
    }
  }
);

// Thunk for updating a category status
export const updateCategoryStatus = createAsyncThunk(
  "category/updateCategoryStatus",
  async (data, thunkAPI) => {
    try {
      const response = await asyncUpdateCategoryStatus(data);
      const successMessage = response?.msg || "Category updated successfully";
      thunkAPI.dispatch(showToast({ type: "success", msg: successMessage }));
      return response;
    } catch (error) {
      const errorMessage = error?.msg || error.message || "Error updating category status";
      thunkAPI.dispatch(showToast({ type: "error", msg: errorMessage }));
      throw error;
    }
  }
);

// Thunk for deleting a category
export const deleteCategory = createAsyncThunk(
  "category/deleteCategory",
  async (req, thunkAPI) => {
    try {
      const response = await asyncDeleteCategory(req);
      console.log("Deleted category response:", response);
      const successMessage = response?.msg || "Category deleted successfully";
      thunkAPI.dispatch(showToast({ type: "success", msg: successMessage }));
      return response;
    } catch (error) {
      const errorMessage = error?.msg || error.message || "Error deleting category";
      thunkAPI.dispatch(showToast({ type: "error", msg: errorMessage }));
      throw error;
    }
  }
);

// Thunk for bulk deleting categories
export const bulkDeleteCategory = createAsyncThunk(
  "category/bulkDeleteCategory",
  async (data, thunkAPI) => {
    try {
      const response = await asyncBulkDeleteCategory(data);
      const successMessage = response?.msg || "Categories deleted successfully";
      thunkAPI.dispatch(showToast({ type: "success", msg: successMessage }));
      return data.categoryIds;
    } catch (error) {
      const errorMessage = error?.msg || error.message || "Error deleting categories";
      console.log("Bulk delete error:", error);
      thunkAPI.dispatch(showToast({ type: "error", msg: errorMessage }));
      throw error;
    }
  }
);
